import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Table,
  Input,
  Button,
} from "reactstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import {
  addMealCategory,
  deleteMealCategory,
  editMealCategory,
  fetchMealCategoryById,
  fetchMealCategoryList,
} from "../../slices/thunks";
import AddCategoryModal from "../../Components/Common/AddCategoryModal";
import EditCategoryModal from "../../Components/Common/EditCategoryModal";
import ConfirmModal from "../../Components/Common/ConfirmModal";
import CustomPagination from "../../Components/Common/CustomePagination";

const MealCategoryList = () => {
  const dispatch = useDispatch();

  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [debounceSearch, setDebouncedSearch] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [categoryIdToDelete, setCategoryIdToDelete] = useState(null);

  // Selector with reselect
  const selectMealCategoryListState = (state) => state;

  const mealCategorySelector = createSelector(
    selectMealCategoryListState,
    (state) => ({
      categories: state.MealCategory.categories,
      loading: state.MealCategory.loading,
      error: state.MealCategory.error,
      pagination: state.MealCategory.pagination,
      selectedCategory: state.MealCategory.selectedCategory,
    })
  );

  const { categories, loading, error, pagination, selectedCategory } =
    useSelector(mealCategorySelector);

  const toggleModal = () => setIsAddModalOpen(!isAddModalOpen);
  const toggleEditModal = () => {
    setEditModalOpen(!isEditModalOpen);
  };

  const handleAddCategory = async (formData) => {
    try {
      await dispatch(addMealCategory(formData));
      toggleModal();
      setPageNo(0);
      dispatch(
        fetchMealCategoryList({
          pageNo: 0,
          pageSize,
          sortBy: "createdAt",
          sortOrder: "DESC",
          isPagination: 1,
          searchTerm: debounceSearch.trim(),
        })
      );
    } catch (error) {}
  };

  const handleEdit = async (categoryId) => {
    await dispatch(fetchMealCategoryById(categoryId));
    setEditModalOpen(true);
  };
  const handleUpdateCategory = async (formData) => {
    try {
      await dispatch(editMealCategory(formData));
      toggleEditModal();
      // setEditModalOpen(false);
      setPageNo(0);
      dispatch(
        fetchMealCategoryList({
          pageNo: 0,
          pageSize,
          sortBy: "createdAt",
          sortOrder: "DESC",
          isPagination: 1,
          searchTerm: debounceSearch.trim(),
        })
      );
    } catch (error) {
      console.error("Failed to add category:", error);
    }
  };

  const toggleConfirmModal = () => setIsConfirmModalOpen(!isConfirmModalOpen);

  const handleDeleteClick = (id) => {
    setCategoryIdToDelete(id);
    setIsConfirmModalOpen(true);
  };

  const confirmDelete = async () => {
    if (categoryIdToDelete) {
      await dispatch(deleteMealCategory(categoryIdToDelete));
      setCategoryIdToDelete(null);
      await dispatch(
        fetchMealCategoryList({
          pageNo: 0,
          pageSize,
          sortBy: "createdAt",
          sortOrder: "DESC",
          isPagination: 1,
          searchTerm: debounceSearch.trim(),
        })
      );
    }
  };

  // const handleDelete = (id) => {
  //   dispatch(deleteMealCategory(id));
  // };

  useEffect(() => {
    const delay = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500);

    return () => clearTimeout(delay);
  }, [searchTerm]);

  useEffect(() => {
    dispatch(
      fetchMealCategoryList({
        pageNo,
        pageSize,
        sortBy: "createdAt",
        sortOrder: "DESC",
        isPagination: 1,
        searchTerm: debounceSearch.trim(),
      })
    );
  }, [dispatch, pageNo, pageSize, debounceSearch]);

  document.title = "Meal Categories";

  return (
    <div className="page-content">
      <Container fluid>
        <Card>
          <CardHeader className="d-flex align-items-center flex-wrap gap-2">
            <h4 className="card-title mb-0 me-2">Meal Category List</h4>

            <div className="search-box ms-3">
              <Input
                type="text"
                className="form-control search"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setPageNo(0);
                }}
              />
              <i className="ri-search-line search-icon"></i>
            </div>

            <div className="ms-auto">
              <button
                type="button"
                className="btn btn-success btn-sm"
                color="success"
                size="sm"
                onClick={toggleModal}
              >
                <i className=" align-middle me-1"></i> Add Category
              </button>
            </div>
          </CardHeader>

          <CardBody>
            <div className="table-responsive">
              <Table className="table align-middle table-nowrap">
                <thead className="table-light text-center">
                  <tr>
                    <th>Sr No</th>
                    <th>Name</th>
                    <th>Image</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <>
                      {[...Array(pageSize)].map((_, index) => (
                        <tr key={index}>
                          <td className="text-center">
                            {/* <Skeleton height={25} width={40} /> */}

                            <Skeleton height={25} width={40} />
                          </td>

                          <td className="text-center">
                            <Skeleton height={25} width={150} />
                          </td>

                          <td className="">
                            <div className="d-flex align-items-center gap-2">
                              <div className="avatar-xl mx-auto">
                                <div className="avatar-title  bg-white rounded">
                                  <Skeleton squre height={60} width={70} />
                                </div>
                              </div>
                            </div>
                          </td>

                          <td className="text-center">
                            <Skeleton height={25} width={40} />
                          </td>
                        </tr>
                      ))}
                    </>
                  ) : error ? (
                    <tr>
                      {/* <td colSpan="4" className="text-danger text-center">
                        {error}
                      </td> */}
                    </tr>
                  ) : categories.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center text-danger">
                        No Meal Categories Found
                      </td>
                    </tr>
                  ) : (
                    categories.map((item, index) => (
                      <tr key={item?.id}>
                        <td className="text-center">
                          {pageNo * pageSize + index + 1}
                        </td>
                        <td className="text-center">{item?.name}</td>
                        <td className="d-flex align-items-center gap-2">
                          <div className="avatar-xl mx-auto">
                            <div className="avatar-title  bg-white rounded">
                              <img
                                src={item?.images}
                                alt={item?.name}
                                className="img-fluid rounded"
                              />
                            </div>
                          </div>
                        </td>

                        <td>
                          <div className="d-flex gap-2 justify-content-center">
                            <button
                              type="button"
                              className="btn btn-sm btn-soft-success"
                              onClick={() => handleEdit(item?.id)}
                            >
                              <i className="ri-pencil-line align-middle"></i>{" "}
                              Edit
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-soft-danger"
                              onClick={() => handleDeleteClick(item?.id)}
                            >
                              <i className="ri-delete-bin-line align-middle"></i>{" "}
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>

            <CustomPagination
              currentPage={pagination?.currentPage}
              totalPages={pagination?.totalPages}
              onPageChange={(page) => setPageNo(page)}
              pageSize={pageSize}
              setPageSize={setPageSize}
              setPageNo={setPageNo}
            />
          </CardBody>
        </Card>

        <AddCategoryModal
          isOpen={isAddModalOpen}
          toggle={toggleModal}
          onSubmit={handleAddCategory}
        />

        <EditCategoryModal
          isOpen={isEditModalOpen}
          toggle={toggleEditModal}
          onSubmit={handleUpdateCategory}
          initialData={selectedCategory}
        />

        <ConfirmModal
          isOpen={isConfirmModalOpen}
          toggle={toggleConfirmModal}
          title="Delete Category"
          message="Are you sure you want to delete this category?"
          onConfirm={confirmDelete}
        />
      </Container>
    </div>
  );
};

export default MealCategoryList;
